<div class="work-chart-progress">
  <div [style.width.%]="percentageReached()" class="work-chart-progress-reached"></div>
  @if (showNumbers()) {
    <div class="work-chart-progress-numbers">
      {{ reached() }}@if (showTotal()) {
      <span>/{{ total() }}</span>
    }
      @if (showPercentage()) {
        <span>%</span>
      }
    </div>
  }
</div>
